export default "__VITE_ASSET__U8sfYAiP__"